import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import { getToken } from '../utils/auth'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    tokenYE: getToken('tokenYE') != null ? getToken('tokenYE') : null
  },
  getters,
  mutations,
  actions,
  namespaced: true
})
